import React from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider.v2';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url, URLS, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import AddItemCard from '../../_partials/AddItemCard';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import { ShopItemType } from '../../../../../../types/shop';
import ShopThumb, {
  ShopThumbType,
  DEFAULT_THUMB_HEIGHT,
  PANEL_HEIGHT,
} from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import EmptyState from '../../_partials/EmptyState';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  streamId: string;
  moduleId: number;
  prints: PapiDeviation[];
  total: number;
  isOwner: boolean;
  username: string;
  isMobile?: boolean;
  isPaywallUpdates?: boolean;
}

export class PrintsSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      t,
      streamId,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      prints,
      total,
      username,
      isMobile,
      isOwner,
      isPaywallUpdates,
      section,
      zone,
    } = this.props;

    const isEmpty = !prints.length;
    const showAddItemCard = isPaywallUpdates && isOwner;

    // dont show empty state - https://phrac.deviantart.net/T57297 & https://phrac.deviantart.net/T57418
    if (isEmpty && !isOwner) {
      return null;
    }

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('common.prints_other')}
        count={total}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={
          <EmptyState
            view="wide"
            shopItemType={ShopItemType.PRINTS}
            biData={BiData<DefaultBiEvent>({
              evid: 2,
              click_info: 'create_print',
              sectionname: 'prints',
            })}
          />
        }
        seeAllUrl={Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PRINTS
        )}
        headerClassName={this.props.headerClassName}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={prints}
          parent={{ title: t('duperbrowse.backButton.profile.shop') }}
        >
          {isMobile ? (
            <SwipeSlider startSlide={showAddItemCard ? 1 : 0}>
              {showAddItemCard && (
                <AddItemCard
                  title={t('pages.shop.prints.addItem.title')}
                  subtitle={t('pages.shop.prints.addItem.subtitle')}
                  onClick={() => window.location.replace(URLS.SUBMIT)}
                  height={PANEL_HEIGHT + DEFAULT_THUMB_HEIGHT}
                  view={'small'}
                  biData={BiData<DefaultBiEvent>({
                    evid: 2,
                    click_info: 'create_print',
                    sectionname: 'prints',
                  })}
                />
              )}
              {prints.map(print => (
                <ShopThumb
                  key={print.deviationId}
                  deviation={print}
                  type={ShopThumbType.PRINT}
                  showAuthor={false}
                />
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize => (
                <>
                  {showAddItemCard && (
                    <AddItemCard
                      title={t('pages.shop.prints.addItem.title')}
                      subtitle={t('pages.shop.prints.addItem.subtitle')}
                      onClick={() => window.location.replace(URLS.SUBMIT)}
                      view={'small'}
                      biData={BiData<DefaultBiEvent>({
                        evid: 2,
                        click_info: 'create_print',
                        sectionname: 'prints',
                      })}
                    />
                  )}
                  {prints.map(print => (
                    <ShopThumb
                      key={print.deviationId}
                      deviation={print}
                      width={elementSize.width}
                      height={elementSize.height + PANEL_HEIGHT}
                      type={ShopThumbType.PRINT}
                      showAuthor={false}
                    />
                  ))}
                </>
              )}
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(PrintsSlider));
